import { useState } from 'react'

//* Components
import Text from 'components/common/Text'

const CollapseItems = ({ data, ...props }) => {
    const [isActive, setIsActive] = useState(false)

    return (
        <div className={'accordion'}>
            <div
                className={'accordionSummary'}
                onClick={() => {
                    setIsActive(!isActive)
                }}
            >
                <Text tag={'h7'} className={'h7 geoSemiBold accordionTitle'} text={data.title} />
                <span className={`icon ${isActive ? 'active' : ''}`} />
            </div>
            <div className={`collapse ${isActive ? 'collapseOpened' : ''}`}>
                <div dangerouslySetInnerHTML={{ __html: data.text }} className='dangerHTML' />
            </div>
        </div>
    )
}

export default CollapseItems
